/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * ``POST /inbox/threads/bulk-mark`` body — mark many threads read/unread
 * for the caller in one request. ``read=True`` marks read, ``False`` unread.
 */
export interface BulkMarkThreadsRequest {
  /**
     * @minItems 1
     * @maxItems 50
     */
  thread_ids: string[];
  read: boolean;
}
